import type { AddressFM } from 'af-root/scenes/Company/WorkOrders/Order/formModel';

import { isValidTextInput } from '@acceligentllc/shared/utils/text';

export const validateAddress = (values: AddressFM) => {
	const errors: ValidationErrors = {};

	if (!values?.location && (!values?.notes && (!values?.street && !values?.city && !values?.neighborhood))) {
		errors.location = 'Either street or notes are required';
	}

	if (values?.street && !isValidTextInput(values.street)) {
		errors.location = 'Street is not valid';
	}

	if (values?.notes && !isValidTextInput(values.notes)) {
		errors.notes = 'Notes are not valid';
	}

	return Object.keys(errors).length === 0 ? null : errors;
};
